/**
 * Zoom Meeting SDK Component View — CDN loader.
 *
 * Do NOT preload bootstrap.css / react-select.css: those paths are Client View only
 * and return 403 on source.zoom.us for recent SDK versions. ZoomMtgEmbedded.createClient()
 * injects its own styles during init().
 */
import i18n from '../i18n';

const ZOOM_SDK_VERSION = '6.2.0';
const BASE = `https://source.zoom.us/${ZOOM_SDK_VERSION}`;

const SCRIPTS = [
  `${BASE}/lib/vendor/react.min.js`,
  `${BASE}/lib/vendor/react-dom.min.js`,
  `${BASE}/lib/vendor/redux.min.js`,
  `${BASE}/lib/vendor/redux-thunk.min.js`,
  `${BASE}/lib/vendor/lodash.min.js`,
  `${BASE}/zoom-meeting-embedded-${ZOOM_SDK_VERSION}.min.js`,
];

let loadPromise = null;

function loadScript(src) {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = src;
    script.async = false;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(i18n.t('classroom.meeting.scriptLoadFailed', {
      src,
      defaultValue: `Failed to load Zoom script: ${src}`,
    })));
    document.body.appendChild(script);
  });
}

/**
 * @returns {Promise<{ createClient: Function }>}
 */
export function loadZoomMeetingSdkEmbedded() {
  if (typeof window !== 'undefined' && window.ZoomMtgEmbedded?.createClient) {
    return Promise.resolve(window.ZoomMtgEmbedded);
  }
  if (!loadPromise) {
    loadPromise = (async () => {
      for (const src of SCRIPTS) {
        await loadScript(src);
      }
      if (!window.ZoomMtgEmbedded?.createClient) {
        throw new Error(i18n.t('classroom.meeting.sdkLoadFailed', {
          defaultValue: 'Zoom Meeting SDK failed to load.',
        }));
      }
      return window.ZoomMtgEmbedded;
    })().catch((err) => {
      loadPromise = null;
      throw err;
    });
  }
  return loadPromise;
}
